module.exports = __webpack_public_path__ + "img/69.4c12cdb7.jpg";